import React from 'react'
import logo from '../../../images/404.svg'

function ErrorModule() {
    return (
        <div style={{ height: "inherit" }}>
            <div style={{ display: "flex", justifyContent: "center",flexDirection: "column",alignItems: "center", height: "inherit" }}>
                <img
                    src={logo}
                    alt="404 Logo"
                    style={{ width: "30vw" }}
                />
                <p style={{ margin: "0px", fontSize: "3rem", fontWeight: "700" }}>404</p>
                <p style={{ margin: "0px", fontSize: "1.2rem" }}>Page Not Found</p>
            </div>
        </div>
    )
}

export default ErrorModule